<mat-card appearance="outlined" telemetry="Card-UserDefinedFields">

  <mat-card-header fxLayout="row" fxLayoutAlign="space-between start">
    <mat-card-title>
      User Defined Fields
    </mat-card-title>
    @if (isLoaded && !viewOnly) {
      <user-defined-field-menu [fields]="fields" (addNewField)="onAddNewField($event)">
      </user-defined-field-menu>
    }
  </mat-card-header>

  <mat-card-content>
    @if (!isLoaded) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    @if (isLoaded) {
      @if (!fields) {
        <div fxLayout="column">
          <div class="emptyIcon iconCircle">
            <mat-icon class="emptyIconContainer" fontIcon="note">
            </mat-icon>
            <span><b>No fields yet</b></span>
          </div>
        </div>
      }
      @if (fields) {
        <div fxLayout="row wrap" fxLayoutAlign="space-between start">
          @for (field of fields; track field) {
            @if (field.Active) {
              <user-defined-field fxFlex.gt-md="25" fxFlex.md="33" fxFlex="50" [field]="field" [viewOnly]="viewOnly">
              </user-defined-field>
            }
          }
        </div>
      }
      @if (errorMessage) {
        <div>
          {{errorMessage}}
        </div>
      }
    }

  </mat-card-content>

  <mat-card-actions>
    <command-bar [commands]="commands">
    </command-bar>
  </mat-card-actions>
</mat-card>